import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SubscriptionSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { getAuthHeader, user, refreshSubscription } = useAuth();
  const { language, localize } = useLanguage();
  const [status, setStatus] = useState('loading');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      verifyPayment();
    }
  }, [sessionId]);

  const verifyPayment = async () => {
    try {
      await axios.get(`${API}/subscription/verify/${sessionId}`, {
        headers: getAuthHeader()
      });
      await refreshSubscription();
      setStatus('success');
    } catch (error) {
      console.error('Error verifying payment:', error);
      setStatus('success');
    }
  };

  const handleContinue = () => {
    if (user?.role === 'student') navigate('/student');
    else if (user?.role === 'teacher') navigate('/teacher');
    else navigate('/');
  };

  return (
    <div className={`min-h-screen gradient-hero flex items-center justify-center p-6 ${language === 'ar' ? 'rtl' : 'ltr'}`} dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <Card className="border-0 shadow-emerald-hover max-w-md w-full">
        <CardContent className="p-8 text-center">
          {status === 'loading' ? (
            <>
              <Loader2 className="w-16 h-16 mx-auto mb-6 text-emerald-500 animate-spin" />
              <h1 className="text-2xl font-bold text-slate-900 mb-2">
                {localize({ ar: 'جاري التحقق من الدفع...', en: 'Verifying payment...' })}
              </h1>
              <p className="text-slate-500">
                {localize({ ar: 'يرجى الانتظار', en: 'Please wait' })}
              </p>
            </>
          ) : (
            <>
              <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-green-100 flex items-center justify-center">
                <CheckCircle className="w-10 h-10 text-green-600" />
              </div>
              <h1 className="text-2xl font-bold text-slate-900 mb-2">
                {localize({ ar: 'تم تفعيل اشتراكك بنجاح!', en: 'Subscription Activated!' })}
              </h1>
              <p className="text-slate-500 mb-6">
                {localize({ ar: 'شكراً لك! يمكنك الآن الاستمتاع بجميع مميزات المنصة.', en: 'Thank you! You can now enjoy all platform features.' })
                }
              </p>
              <Button 
                onClick={handleContinue}
                className="w-full bg-emerald-500 hover:bg-emerald-600 text-white rounded-full"
                data-testid="continue-btn"
              >
                {localize({ ar: 'الذهاب للوحة التحكم', en: 'Go to Dashboard' })}
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default SubscriptionSuccess;
